import { CircularProgress } from '@mui/material';
import { ArrowRightRounded, CheckCircleRounded } from '@mui/icons-material';
import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick';
import { handleListTeachers } from 'store/bingo/thunks';
import { useTeachersBingo } from 'store/bingo/selectors';
import GameLoader from "../../components/OneGame/GameLoaader";
import { useCurrentUser } from 'store/users/selectors';
import { get } from 'lodash';
import Loading from 'components/Loading';
import PreviewLoteria from './ListModals/PreviewLoteria';
import PrintLoteria from './PrintBingo/PrintLoteria';
import { useClassUsers } from 'store/userClasses/selectors';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import CloneLoteriaModal from './ListModals/CloneLoteriaModal';
import { handleListOneWayBingo } from 'store/bingo/thunks';


const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <i className='fa' aria-hidden='true'></i>
        </div>
    );
};

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    className: "center",
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
        {
            breakpoint: 1092,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 414,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function AllTeachersBingo({ 
    showDrawer, 
    setCurrentSection, 
    bookId, 
    pageId, 
    userId, 
    gameDuplicateLoader, 
    startGame, 
    gameInitLoader, 
    onDuplicateGame = () => { }, 
    gameType, 
    newMaskId 
}) {
    const showAlert = useAlert();
    const [isLoading, setLoading] = useState(true);
    const [selectedGame, setSelectedGame] = useState({})
    const [cloneModalOpen, setCloneModalOpen] = useState(false);
    const [selectedLoteriaForClone, setSelectedLoteriaForClone] = useState(null);
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const isAdmin = get(currentUser, "role") === "owe_admin";
    const bingoData = useTeachersBingo();
    const classUsers = useClassUsers();
    const classStudentUsers = classUsers?.filter(
        (obj) => obj?.role === "student"
    );

    const loadData = async () => {
        setLoading(true)
        const bingoList = {
            chapter: bookId,
            page: pageId,
            user_id: get(currentUser, 'id', '')
        }
        await dispatch(handleListTeachers(bingoList));
        setLoading(false);
    }
    
    useEffect(() => {
        loadData();
    }, [pageId, gameType])
    
    if (isLoading) {
        return (<GameLoader />);
    }
    
    if (bingoData.length == 0) {
        return (<div class="skeleton-wrapper">
            <div class="skeleton-card" style={{ textAlign: "center" }}>No lotería games available!</div>
        </div>
        )
    }

    return (
        <>
            <Slider {...settings}>
                {bingoData && bingoData?.map((item, index) => {
                    const isGameLoading = gameInitLoader && selectedGame.id === item.id
                    return (
                        <div className='myUnitsGm' key={item.id} style={{ overflow: "hidden" }}>
                            <div className='draftImage-game frameStyle'>
                                <PreviewLoteria 
                                    grid={typeof item?.bingo_data === 'string' ? JSON.parse(item.bingo_data || '[]') : item?.bingo_data || []} 
                                    bingoSize={item?.configurations?.bingo_size} 
                                    selectedType={item?.bingo_type} 
                                />
                                {item?.status === 'false' && (
                                    <div className='draftText-game'>Draft</div>
                                )}
                            </div>
                            <div className='myUnitsTxt'>
                                <div className='myUnitsInfo'>
                                    {item?.criteria && item.criteria.length > 20 ? (
                                        <Tooltip title={item.criteria}>
                                            <label className='text-dark'>{item?.criteria.slice(0, 20) + '...'}</label>
                                        </Tooltip>
                                    ) : (
                                        <label className='text-dark'>{item?.criteria || 'Untitled'}</label>
                                    )}
                                    {newMaskId ? (
                                        <span>Pg. {newMaskId || '--'}</span>
                                    ) : (
                                        <span>Pg. {pageId || '--'}</span>
                                    )}
                                    <span>
                                        Lotería Size: {item?.configurations?.bingo_size
                                            ? `${item.configurations.bingo_size} X ${item.configurations.bingo_size}`
                                            : '--'}
                                    </span>
                                </div>
                                <div className='myUnitsBtns'>
                                    <PrintLoteria
                                        bingoSize={item?.configurations?.bingo_size}
                                        selectedType={item?.bingo_type}
                                        grid={typeof item?.bingo_data === 'string' ? JSON.parse(item.bingo_data || '[]') : item?.bingo_data || []}
                                        classUsers={classStudentUsers}
                                        isGridValid={true}
                                        showSnack={showAlert}
                                    />
                                    {!isAdmin && (
                                    <a onClick={() => {
                                        if (isGameLoading || gameInitLoader) {
                                            return false;
                                        }
                                        if (item?.bingo_data?.length > 0) {
                                            setSelectedGame(item);
                                            startGame(item);
                                        }
                                    }}
                                        className={`BtnsStart ${item?.bingo_data?.length === 0 ? "btn-disabled-game" : ''}`}>
                                        <ArrowRightRounded />{gameInitLoader && selectedGame.id === item.id ? <Loading size={12} white /> : null} start
                                    </a>
                                    )}
                                </div>
                                <div className='myUnitsBtm'><p><CheckCircleRounded /> Teacher Created</p></div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px' }} className="px-4">
                                    <div onClick={() => {
                                        onDuplicateGame(item)
                                    }}>
                                        <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>
                                            {gameDuplicateLoader === item.id ? <CircularProgress size={15} style={{ color: 'teal' }} /> : null} 
                                            Duplicate
                                        </p>
                                    </div>
                                    <div onClick={(e) => {
                                        try {
                                            e?.preventDefault?.();
                                            const cleanLoteria = {
                                                id: item?.id || null,
                                                criteria: item?.criteria || 'Untitled'
                                            };
                                            setSelectedLoteriaForClone(cleanLoteria);
                                            setCloneModalOpen(true);
                                        } catch (err) {
                                            console.error('Error opening clone modal:', err?.message);
                                        }
                                    }}>
                                        <p className='text-dark' style={{ fontSize: 16, fontWeight: '600', cursor: 'pointer' }}>
                                            Clone
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
            <CloneLoteriaModal
                open={cloneModalOpen}
                onClose={() => {
                    setCloneModalOpen(false);
                    setSelectedLoteriaForClone(null);
                }}
                cloneGame={selectedLoteriaForClone}
                bookId={bookId}
                pageId={pageId}
                onSuccess={async (clonedData) => {
                    await loadData();
                    const bingoList = {
                        chapter: bookId,
                        page: pageId,
                        role: get(currentUser, 'role', ''),
                        user_id: get(currentUser, 'id', '')
                    };
                    await dispatch(handleListOneWayBingo(bingoList));
                }}
            />
        </>
    )
}
